module.exports = __webpack_public_path__ + "static/hero-about-ef1b87e3be60070741134b801dac3b5f.png";